let modalRootElement: HTMLElement | null = null

/**
 * Get the modal root element.
 *
 * Ensures that the modal root element is present in the DOM.
 * Also acts as a type guard for the modal root element.
 *
 * @returns The modal root element.
 * @throws An error if the modal root element is not found.
 */
export const modalRoot = () => {
    modalRootElement = modalRootElement ?? document.getElementById('modal-root')

    if (!modalRootElement) {
        throw new Error('modal-root element not found.')
    }

    return modalRootElement
}
